import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, Optional } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

export interface LabelThresholdDialogData {
  threshold: number;
}

/**
 * Focused dialog for an option's display threshold: the minimum probability
 * needed for the label to be considered truthy. Closes with the confirmed
 * number, or `undefined` on cancel/backdrop/ESC.
 */
@Component({
  selector: 'ts-label-threshold-dialog',
  templateUrl: './label-threshold-dialog.component.html',
  styleUrls: ['./label-threshold-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, TranslateModule, MatDialogModule],
})
export class LabelThresholdDialogComponent {
  public readonly thresholdControl: FormControl<number | null>;

  constructor(
    @Optional()
    public readonly dialogRef: MatDialogRef<LabelThresholdDialogComponent, number | undefined> | null,
    @Optional()
    @Inject(MAT_DIALOG_DATA)
    public readonly data: LabelThresholdDialogData | null
  ) {
    this.thresholdControl = new FormControl<number | null>(data?.threshold ?? 0, [
      Validators.required,
      Validators.min(0),
      Validators.max(1),
    ]);
  }

  public submit(): void {
    if (this.thresholdControl.invalid) return;
    this.dialogRef?.close(Number(this.thresholdControl.value));
  }

  public cancel(): void {
    this.dialogRef?.close(undefined);
  }
}
